import { createGlobalStyle } from "styled-components";
import "@wordpress/block-library/build-style/style.css";

export const GlobalStyle = createGlobalStyle`
   @font-face {
      font-family:  ${({ theme }) => theme.fontLinks.fontFamily};
      font-style: normal;
      font-weight: normal;
      font-display: swap;
      src: 
        url("${({ theme }) => theme.fontLinks.woff2}") format("woff2"),
        url("${({ theme }) => theme.fontLinks.woff}") format("woff");
    }
   @font-face {
      font-family:  ${({ theme }) => theme.fontHeadings.fontFamily};
      font-style: normal;
      font-weight: normal;
      font-display: swap;
      src: 
        url("${({ theme }) => theme.fontHeadings.woff2}") format("woff2"),
        url("${({ theme }) => theme.fontHeadings.woff}") format("woff");
    }
   @font-face {
      font-family:  ${({ theme }) => theme.fontParagraphs.fontFamily};
      font-style: normal;
      font-weight: normal;
      font-display: swap;
      src: 
        url("${({ theme }) => theme.fontParagraphs.woff2}") format("woff2"),
        url("${({ theme }) => theme.fontParagraphs.woff}") format("woff");
    }

:root {
  --color-primary: ${({ theme }) => theme.colors.primary};
  --color-secondary: ${({ theme }) => theme.colors.secondary};
  --color-black: ${({ theme }) => theme.colors.black};
  --color-white: ${({ theme }) => theme.colors.white};
  --color-grey: #DFDFDF;
  --color-dark-grey: #2a2a2a;
  --color-hover-button: #363636;
  --color-green: #5f8e67;
  --color-accent1: ${({ theme }) => theme.colors.accent1};
  --color-accent2: ${({ theme }) => theme.colors.accent2};
  --color-accent3: ${({ theme }) => theme.colors.accent3};
  --color-body: ${({ theme }) => theme.colors.body};
  --color-body-text: ${({ theme }) => theme.colors.bodyText};
  --color-body-link: ${({ theme }) => theme.colors.bodyLink};
  --border-radius: ${({ theme }) => theme.borderRadius};
  --box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
  --font-paragraph:  ${({ theme }) => theme.fontParagraphs.fontFamily};
  --font-headings: ${({ theme }) => theme.fontHeadings.fontFamily};
  --font-paragraphs: ${({ theme }) => theme.fontParagraphs.fontFamily};
  --font-links: ${({ theme }) => theme.fontLinks.fontFamily};
}

* {
  box-sizing: border-box;
}
  body {
    box-sizing: border-box;
    font-family: ${({ theme }) => theme.typography.fontFamily}, "sans-serif";
    margin: 0;
        background-color: ${({ theme }) => theme.colors.body};
    color: ${({ theme }) => theme.colors.bodyText}
  }
  @media all and (-ms-high-contrast: none),
  (-ms-high-contrast: active) {

  /* IE10+ CSS styles go here */

  }
  .breadcrumbs-wrapper {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .breadcrumbs-wrapper::-webkit-scrollbar {
    display: none;
  }
  .animate-disabled {
    transform: none !important;
    opacity: 1 !important;
    transition-duration: 0 !important;
  }
  section {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    margin: 60px 0;
  }
  ul, ol {
    width: 100%;
  }
 
  a {
    color: ${({ theme }) => theme.colors.bodyLink};
    font-family: ${({ theme }) => theme.fontLinks.fontFamily} , "sans-serif";
  }
  button {
    font-family: ${({ theme }) =>
      theme.fontParagraphs.fontFamily}, "sans-serif";
    border: none;
    cursor: pointer;
    outline: none;
  }
  .button {
    padding: 13px 25px 11px 25px;
    font-size: 1rem;
    text-decoration: none;
    transition: 0.3s all ease-in-out;
    font-family: ${({ theme }) =>
      theme.fontParagraphs.fontFamily}, "sans-serif";
    max-width: 300px;
    margin: 5px 10px 5px 0;
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.black};
    border: 1px solid ${({ theme }) => theme.colors.black};
    outline: none;
    &:hover {
      text-decoration: none;
      cursor: pointer;
      color: ${({ theme }) => theme.colors.black};
      border: 1px solid #000;
    }
    &.secondary {
      background-color: transparent;
      color: ${({ theme }) => theme.colors.white};
      border: 1px solid ${({ theme }) => theme.colors.white};
      &:hover {
        background-color: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.black};
      }
    }
  }
  p {
    letter-spacing: 1px;
    line-height: 1.5;
    font-size: 1rem;
    width: 100%;
    font-family: ${({ theme }) =>
      theme.fontParagraphs.fontFamily}, "sans-serif";
  }
  div {
    line-height: 1.5;
  }
  h1, h2, h3, h4, h5, h6 {
    width: 100%;
    margin: 5px 0;
    font-weight: unset;
    font-family: ${({ theme }) => theme.fontHeadings.fontFamily}, "sans-serif";
  }
  ul::not('.__header') {
    width: 100%;
    li {
        &:before {
        content: "\\2022";
        color: ${({ theme }) => theme.colors.primary};
        font-weight: 700;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
      }
    }
  }
  strong {
    font-family:${({ theme }) => theme.fontHeadings.fontFamily}, "sans-serif";
  }
  .margin-bottom {
    margin-bottom: 20px;
  }
  .img-width {
    width: 100%;
  }
  .row-container {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1.5rem;
    margin: 30px 0;
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}){
      margin: 0;
      flex-wrap: wrap;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      justify-content: flex-start;
      flex-direction: column;
    }
  }
  .employee-card-container {
    display: flex;
    justify-content: flex-start;
    flex-wrap: no-wrap;
    gap: 1rem;
    width: 100%;
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
     flex-direction: column;
    }
  }
  .faq-container {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    border-radius: 0.2rem;
  }
  .metric-wrapper {
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      justify-content: space-around!important;
    }
  }
  .button-container {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    margin-block: 0.625rem;
    gap: 0.625rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}){
      margin: 0;
      justify-content: center;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      justify-content: center;
    }
  }
  .button-margin-wide {
    margin: 5px 25px !important;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}){
      margin: 10px;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      margin: 10px;
      width: 44%;
    }
  }
  .door-container {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, max-content));
    padding: initial;
    justify-content: flex-start;
    @media (min-width: 700px){
      grid-template-columns: repeat(auto-fit, minmax(230px, max-content));
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.wide}){
      grid-template-columns: repeat(auto-fit, minmax(238px, max-content));
    }
  }

  .hero__headline {
    font-weight: 300;
    font-size: 40px;
    margin-bottom: 10px;
    text-shadow: 0px 1px 6px rgba(0, 0, 0, 0.16);
  }
  .hero__subline {
    text-transform: uppercase;
    font-size: 40px;
    font-weight: 600;
    margin: 0 0 1rem 0;
    text-shadow: 0px 1px 6px rgba(0, 0, 0, 0.26);
  }
  
  .contact-container {
    height: 100vh;
    padding: 40px 0;
    justify-content: center;
    align-items: flex-start;
    margin: 0;
    width: 100%;
  }
  .contactForm {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    justify-content: flex-start;
    text-align: left;
    div:first-child {
      width: 95%;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
      justify-content: center;
      flex-flow: column wrap;
      max-width: 100%;
    }
    form {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
        justify-content: center;
        align-items: center;
        width: 100%;
      }
      p {
        font-size: 0.75rem;
        margin-bottom: 5px;

        .red-dot {
          color: red;
        }
      }
    }
    label {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin: 5px 0;
    }
    .wpcf7-list-item label {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .half-wrapper {
      display: flex;
      width: 100%;
      align-items: flex-start;
      gap: 1.5rem;
      @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
        max-width: 100%;
        flex-direction: column;
        gap: 0;
      }
    }
    .form-message {
      color: red;
    }
    p span {
      width: 100%;
    }
    input[type=text],
    input[type=tel],
    input[type=email],
    input[type=date],
    input[type=password],
    textarea {
      border-radius: var(--border-radius);
      width: 100%;
      margin: 5px 0;
      -webkit-appearance: none;
      border: 2px solid var(--color-grey);
      background-color: ${({ theme }) => theme.colors.white};
      padding: 20px 20px;
      font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
      font-size: 0.85rem;
      @media (max-width: 1024px) {
        max-width: 100%;
      }
      &:focus {
        outline: none;
        border: 2px solid var(--color-primary);
      }
    }
    input[type=text]::placeholder,
    input[type=tel]::placeholder,
    input[type=email]::placeholder,
    textarea::placeholder {
      color: #000;
    }

    select {
      width: 100%;
      padding: 15px;
      max-width: 640px;
      margin: 5px 0;
      border: 1px solid var(--color-primary);
      background-color: var(--color-white);
    }
   
    .wpcf7-form-control-wrap {
      width: 100%;
      margin-bottom: 10px;
    }
    .wpcf7-radio > span,
    .wpcf7-checkbox > span  {
      display: block;
      cursor: pointer;
      margin: 5px 0;
    }
    input[type=radio] {
      -webkit-appearance: radio;
      margin-left: 0;
      margin-right: 10px;
    }
    input[type=checkbox] {
      width: 18px;
      height: 18px;
      margin-right: 5px;
    }
    input[type=submit] {
      border-radius: var(--border-radius);
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.white};
      border: 1px solid ${({ theme }) => theme.colors.primary};
      padding: 12px 40px;
      font-size: 1rem;
      transition: 0.3s all ease-in-out;
      font-family:${({ theme }) => theme.fontHeadings.fontFamily};
      margin-block: 1rem;
      text-transform: uppercase;
      -webkit-appearance: none;
      width: fit-content;
    
      &:hover {
        text-decoration: none;
        cursor: pointer;
        filter: brightness(85%);
      }
      &:disabled {
        background-color: var(--color-accent2) !important;
        color: #ededed !important;
        cursor: not-allowed !important;
        border: none !important;
        &:hover {
          filter: none;
        }
      }
      @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}){
        max-width: none;
        width: 100%;
      }
    }
    textarea {
      height: 150px;
      resize: none;
      min-width: 640px;
      @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
        min-width: unset;
      }
    }
    .checkbox-text {
      font-size: 10px;
      margin-left: 0.5rem;
    }
    .form-input-required-message {
      margin-top: 0px;
      color: red;
      font-size: 0.8rem;
    }
  }
  .active-product-link {
    border-bottom: 3px solid ${({ theme }) => theme.colors.primary};
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      border: 1px solid ${({ theme }) => theme.colors.white};
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.white};
    }
  }
  .center {
    text-align: center;
    justify-content: center;
  }
  .wp-block-media-text {
    margin-bottom: 40px;
  }
  .wp-block-media-text:last-child {
    margin-bottom: 0;
  }

  .wp-block-media-text.is-stacked-on-mobile .wp-block-media-text__content {
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      padding: 0;
    }
  }
  .CookieConsent {
    align-items: baseline;
    background: rgb(53, 53, 53) none repeat scroll 0% 0%;
    color: white;
    display: flex;
    flex-wrap: wrap;
    line-height: 1.4;
    justify-content: space-between;
    font-family: ${({ theme }) =>
      theme.fontParagraphs.fontFamily}, "sans-serif";
    left: 0px;
    position: fixed;
    width: 100%;
    z-index: 999;
    bottom: 0px;
    padding: 10px;
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      & div {
        display: flex;
      }
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    & button {
      border-radius: var(--border-radius);
      &:nth-child(2) {
        @media (hover: hover) {
          &:hover {
            background-color: transparent;
            border-color: #fefefe;
            color: #fefefe;
          }
        }
      }
    }
  }
  .cover {
    height: 100%;
  }

  .related-products-container {
    display: grid;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      padding-inline: 2rem;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      padding-inline: 1rem;
    }
  }

   //Override some carousel styles

  .ic1 {
    margin-block: 1rem;
  }

  .ic2 {
    margin-block: 2rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      margin-block: 1rem;
    }
  }
   
  a.bg-accent2{
    &:hover{
      background: var(--color-accent2);
      opacity:0.7;
      color:var(--color-black);
      border-color:var(--color-accent2);
    }
    
  }

  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999999999;
  }
  
  .popup-overlay .popup-content {
    background: #fff;
    width: 80%;
    max-width: 400px;
    padding: 20px;
    border-radius: 5px;
    position: relative;
  }
  
  .popup-overlay .close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    cursor: pointer;
  }
  .popup-overlay input {
    width: 100%;
    margin-bottom: 5%;
  }    

  .bedrift-hero {
    margin-top: 40px;
  }

  .ref-page-table {
    border-collapse: seperate;
    border-spacing: 10px;
  }
  
  ${({ theme }) => theme.customCSS}
`;
